export const AUTH0_SIGNUP_PARAM = 'auth0Signup';
